export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carousel_arrow_right.5a6366ea.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};